var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "slider", class: _vm.sliderClasss },
    [
      _c("mku-slider-drag", {
        ref: "startDrag",
        model: {
          value: _vm.startValue,
          callback: function($$v) {
            _vm.startValue = $$v
          },
          expression: "startValue"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "sliderWrap",
          staticClass: "mku-slider__outer",
          on: { click: _vm.handleBarClick }
        },
        [
          _c("div", { staticClass: "mku-slider__inner", style: _vm.barStyle }),
          _vm._v(" "),
          _vm.showStops || _vm.masks
            ? _c(
                "div",
                { staticClass: "mku-slider__stops" },
                _vm._l(_vm.stops, function(item, index) {
                  return _c("span", {
                    key: index,
                    staticClass: "mku-slider__stops-item",
                    style: _vm.stopsItemStyle(item)
                  })
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.range
        ? _c("mku-slider-drag", {
            ref: "endDrag",
            model: {
              value: _vm.endValue,
              callback: function($$v) {
                _vm.endValue = $$v
              },
              expression: "endValue"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.masks
        ? _c(
            "div",
            { staticClass: "mku-slider__marks" },
            _vm._l(_vm.masks, function(val, key) {
              return _c("mku-slider-mark", {
                key: key,
                attrs: { data: { key: key, val: val } }
              })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }